// modules are defined as an array
// [ module function, map of requires ]
//
// map of requires is short require name -> numeric require
//
// anything defined in a previous bundle is accessed via the
// orig method which is the require for previous bundles

(function (modules, entry, mainEntry, parcelRequireName, globalName) {
  /* eslint-disable no-undef */
  var globalObject =
    typeof globalThis !== 'undefined'
      ? globalThis
      : typeof self !== 'undefined'
      ? self
      : typeof window !== 'undefined'
      ? window
      : typeof global !== 'undefined'
      ? global
      : {};
  /* eslint-enable no-undef */

  // Save the require from previous bundle to this closure if any
  var previousRequire =
    typeof globalObject[parcelRequireName] === 'function' &&
    globalObject[parcelRequireName];

  var cache = previousRequire.cache || {};
  // Do not use `require` to prevent Webpack from trying to bundle this call
  var nodeRequire =
    typeof module !== 'undefined' &&
    typeof module.require === 'function' &&
    module.require.bind(module);

  function newRequire(name, jumped) {
    if (!cache[name]) {
      if (!modules[name]) {
        // if we cannot find the module within our internal map or
        // cache jump to the current global require ie. the last bundle
        // that was added to the page.
        var currentRequire =
          typeof globalObject[parcelRequireName] === 'function' &&
          globalObject[parcelRequireName];
        if (!jumped && currentRequire) {
          return currentRequire(name, true);
        }

        // If there are other bundles on this page the require from the
        // previous one is saved to 'previousRequire'. Repeat this as
        // many times as there are bundles until the module is found or
        // we exhaust the require chain.
        if (previousRequire) {
          return previousRequire(name, true);
        }

        // Try the node require function if it exists.
        if (nodeRequire && typeof name === 'string') {
          return nodeRequire(name);
        }

        var err = new Error("Cannot find module '" + name + "'");
        err.code = 'MODULE_NOT_FOUND';
        throw err;
      }

      localRequire.resolve = resolve;
      localRequire.cache = {};

      var module = (cache[name] = new newRequire.Module(name));

      modules[name][0].call(
        module.exports,
        localRequire,
        module,
        module.exports,
        globalObject
      );
    }

    return cache[name].exports;

    function localRequire(x) {
      var res = localRequire.resolve(x);
      return res === false ? {} : newRequire(res);
    }

    function resolve(x) {
      var id = modules[name][1][x];
      return id != null ? id : x;
    }
  }

  function Module(moduleName) {
    this.id = moduleName;
    this.bundle = newRequire;
    this.exports = {};
  }

  newRequire.isParcelRequire = true;
  newRequire.Module = Module;
  newRequire.modules = modules;
  newRequire.cache = cache;
  newRequire.parent = previousRequire;
  newRequire.register = function (id, exports) {
    modules[id] = [
      function (require, module) {
        module.exports = exports;
      },
      {},
    ];
  };

  Object.defineProperty(newRequire, 'root', {
    get: function () {
      return globalObject[parcelRequireName];
    },
  });

  globalObject[parcelRequireName] = newRequire;

  for (var i = 0; i < entry.length; i++) {
    newRequire(entry[i]);
  }

  if (mainEntry) {
    // Expose entry point to Node, AMD or browser globals
    // Based on https://github.com/ForbesLindesay/umd/blob/master/template.js
    var mainExports = newRequire(mainEntry);

    // CommonJS
    if (typeof exports === 'object' && typeof module !== 'undefined') {
      module.exports = mainExports;

      // RequireJS
    } else if (typeof define === 'function' && define.amd) {
      define(function () {
        return mainExports;
      });

      // <script>
    } else if (globalName) {
      this[globalName] = mainExports;
    }
  }
})({"lccv1":[function(require,module,exports,__globalThis) {
/*
 * Copyright 2024 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "TabsContext", ()=>TabsContext);
parcelHelpers.export(exports, "TabPanel", ()=>TabPanel);
parcelHelpers.export(exports, "Tab", ()=>Tab);
parcelHelpers.export(exports, "TabList", ()=>TabList);
parcelHelpers.export(exports, "Tabs", ()=>_Tabs);
var _jsxRuntime = require("react/jsx-runtime");
var _reactAriaComponents = require("react-aria-components");
var _centerBaseline = require("./CenterBaseline");
var _react = require("react");
var _icon = require("./Icon");
var _content = require("./Content");
var _utils = require("@react-spectrum/utils");
var _utils1 = require("@react-aria/utils");
var _i18N = require("@react-aria/i18n");
var _useSpectrumContextProps = require("./useSpectrumContextProps");
const TabsContext = /*#__PURE__*/ (0, _react.createContext)(null);
const tabPanel = function anonymous(props, overrides) {
    let rules = " .";
    let matches = (overrides || '').match(/(?:^|\s)(?:y|z|A|B|_9|_8|h|_5|_4|__A|__c|__d|__a|__b|U|__Q|X|Z|V|W|l|q|r|k|o|p)[^\s]+/g) || [];
    rules += matches.join('');
    let $A = false;
    let $_9 = false;
    let $h = false;
    let $o = false;
    let $q = false;
    for (let p of matches){
        if (/^\s*A/.test(p)) $A = true;
        if (/^\s*_9/.test(p)) $_9 = true;
        if (/^\s*h/.test(p)) $h = true;
        if (/^\s*o/.test(p)) $o = true;
        if (/^\s*q/.test(p)) $q = true;
    }
    if (!$A) rules += ' Ac';
    rules += ' an';
    if (!$_9) rules += ' _9-3t1y';
    if (!$h) rules += ' h-3hmsa';
    if (!$o) rules += ' oo';
    if (!$q) rules += ' qo';
    return rules;
};
function TabPanel(props) {
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactAriaComponents.TabPanel), {
        ...props,
        style: props.UNSAFE_style,
        className: (props.UNSAFE_className || '') + tabPanel(null, props.styles)
    });
}
const tab = function anonymous(props, overrides) {
    let rules = " .";
    let matches = (overrides || '').match(/(?:^|\s)(?:y|z|A|B|_9|_8|h|_5|_4|__A|__c|__d|__a|__b|U|__Q|X|Z|V|W|l|q|r)[^\s]+/g) || [];
    rules += matches.join('');
    let $U = false;
    let $_8 = false;
    for (let p of matches){
        if (/^\s*U/.test(p)) $U = true;
        if (/^\s*_8/.test(p)) $_8 = true;
    }
    if (props.isFocusVisible) rules += ' _Lb';
    else rules += ' _La';
    rules += ' da_____z';
    rules += ' dx';
    rules += ' _Nc';
    rules += ' _M-3t1z';
    rules += ' _Zd';
    if (props.isDisabled) rules += ' aa_____B';
    else if (props.isSelected) rules += ' aa_____z';
    if (props.isDisabled) rules += ' aj';
    else if (props.isHovered) {
        if (props.isPressed) rules += ' an';
        else if (props.isFocusVisible) rules += ' an';
        else if (props.isHovered) rules += ' an';
        else rules += ' am';
    } else if (props.isSelected) {
        if (props.isPressed) rules += ' ao';
        else if (props.isFocusVisible) rules += ' ao';
        else rules += ' an';
    } else {
        if (props.isPressed) rules += ' an';
        else if (props.isFocusVisible) rules += ' an';
        else rules += ' am';
    }
    rules += ' _vb';
    rules += ' _wb';
    rules += ' _xb';
    rules += ' _yb';
    rules += ' ibH';
    rules += ' iG';
    rules += ' jbH';
    rules += ' jG';
    if (props.density === "regular") rules += ' k_a';
    else if (props.density === "compact") rules += ' kU';
    rules += ' _1c';
    if (!$U) rules += ' Uc';
    rules += ' __Hb';
    if (!$_8) rules += ' _8-3t1x';
    rules += ' _Oa';
    rules += ' _Q-375x7f';
    rules += ' _Ra';
    return rules;
};
const icon = " . _8-3t1x -rwx0fg_e-b";
function Tab(props) {
    let { density } = (0, _reactAriaComponents.useSlottedContext)(TabsContext) ?? {};
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactAriaComponents.Tab), {
        ...props,
        style: props.UNSAFE_style,
        className: (renderProps)=>(props.UNSAFE_className || '') + tab({
                ...renderProps,
                density
            }, props.styles),
        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactAriaComponents.Provider), {
            values: [
                [
                    (0, _content.TextContext),
                    {
                        styles: " . __A-3t1y"
                    }
                ],
                [
                    (0, _icon.IconContext),
                    {
                        render: (0, _centerBaseline.centerBaseline)({
                            slot: 'icon',
                            styles: " . __A-3t1x"
                        }),
                        styles: icon
                    }
                ]
            ],
            children: typeof props.children === 'string' ? /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _content.Text), {
                children: props.children
            }) : props.children
        })
    });
}
const tablist = function anonymous(props) {
    let rules = " .";
    rules += ' _Zd';
    if (props.orientation === "horizontal") {
        if (props.density === "regular") rules += ' ij';
        else if (props.density === "compact") rules += ' ih';
    }
    if (props.orientation === "horizontal") {
        if (props.density === "regular") rules += ' jj';
        else if (props.density === "compact") rules += ' jh';
    }
    if (props.orientation === "vertical") rules += ' _6b';
    if (props.orientation === "vertical") rules += ' Dg';
    if (props.orientation === "vertical") rules += ' Ce';
    rules += ' _8-3t1x';
    rules += ' h-3hmsa';
    return rules;
};
function TabList(props1) {
    let { density, isDisabled, disabledKeys, orientation } = (0, _reactAriaComponents.useSlottedContext)(TabsContext) ?? {};
    let state = (0, _react.useContext)((0, _reactAriaComponents.TabListStateContext));
    let [selectedTab, setSelectedTab] = (0, _react.useState)(undefined);
    let tablistRef = (0, _react.useRef)(null);
    (0, _utils1.useLayoutEffect)(()=>{
        if (tablistRef?.current) {
            let tab = tablistRef.current.querySelector('[role=tab][data-selected=true]');
            if (tab != null) setSelectedTab(tab);
        }
    }, [
        tablistRef,
        state?.selectedItem?.key
    ]);
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
        style: props1.UNSAFE_style,
        className: (props1.UNSAFE_className || '') + function anonymous(props, overrides) {
            let rules = " .";
            let matches = (overrides || '').match(/(?:^|\s)(?:y|z|A|B|_9|_8|h|_5|_4|__A|__c|__d|__a|__b|U|__Q|X|Z|V|W|l|q|r)[^\s]+/g) || [];
            rules += matches.join('');
            let $U = false;
            for (let p of matches)if (/^\s*U/.test(p)) $U = true;
            if (!$U) rules += ' Uc';
            return rules;
        }(null, props1.styles),
        children: [
            orientation === 'vertical' && /*#__PURE__*/ (0, _jsxRuntime.jsx)(TabLine, {
                disabledKeys: disabledKeys,
                isDisabled: isDisabled,
                selectedTab: selectedTab,
                orientation: orientation,
                density: density
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactAriaComponents.TabList), {
                ...props1,
                ref: tablistRef,
                className: (renderProps)=>tablist({
                        ...renderProps,
                        density
                    })
            }),
            orientation === 'horizontal' && /*#__PURE__*/ (0, _jsxRuntime.jsx)(TabLine, {
                disabledKeys: disabledKeys,
                isDisabled: isDisabled,
                selectedTab: selectedTab,
                orientation: orientation,
                density: density
            })
        ]
    });
}
function isAllTabsDisabled(collection, disabledKeys) {
    let testKey = null;
    if (collection && collection.size > 0) {
        testKey = collection.getFirstKey();
        let index = 0;
        while(testKey && index < collection.size){
            // We have to check if the item in the collection has a key in disabledKeys or has the isDisabled prop set directly on it
            if (!disabledKeys.has(testKey) && !collection.getItem(testKey)?.props?.isDisabled) return false;
            testKey = collection.getKeyAfter(testKey);
            index++;
        }
        return true;
    }
    return false;
}
const selectedIndicator = function anonymous(props) {
    let rules = " .";
    rules += ' Ua';
    if (props.isDisabled) rules += ' ba_____B';
    else rules += ' ba_____z';
    if (props.isDisabled) rules += ' bg';
    else {
        if (props.isPressed) rules += ' bo';
        else if (props.isFocusVisible) rules += ' bo';
        else if (props.isHovered) rules += ' bo';
        else rules += ' bn';
    }
    if (props.orientation === "horizontal") rules += ' k-375zlr';
    if (props.orientation === "vertical") rules += ' l-375zlr';
    if (props.orientation === "horizontal") rules += ' Za';
    rules += ' wf';
    rules += ' _vf';
    rules += ' _wf';
    rules += ' _xf';
    rules += ' _yf';
    rules += ' _Q-375x5l';
    rules += ' _Ra';
    return rules;
};
function TabLine(props) {
    let { disabledKeys, isDisabled: isTabsDisabled, selectedTab, orientation, density } = props;
    let { direction } = (0, _i18N.useLocale)();
    let state = (0, _react.useContext)((0, _reactAriaComponents.TabListStateContext));
    // We want to add disabled styling to the selection indicator only if all the Tabs are disabled
    let [isDisabled, setIsDisabled] = (0, _react.useState)(false);
    (0, _react.useEffect)(()=>{
        let isDisabled = isTabsDisabled || isAllTabsDisabled(state?.collection || null, disabledKeys ? new Set(disabledKeys) : new Set(null));
        setIsDisabled(isDisabled);
    }, [
        state?.collection,
        disabledKeys,
        isTabsDisabled,
        setIsDisabled
    ]);
    let [style, setStyle] = (0, _react.useState)({
        transform: undefined,
        width: undefined,
        height: undefined
    });
    let onResize = (0, _react.useCallback)(()=>{
        if (selectedTab) {
            let styleObj = {
                transform: undefined,
                width: undefined,
                height: undefined
            };
            // In RTL, calculate the transform from the right edge of the tablist so that resizing the window doesn't break the Tabline position due to offsetLeft changes
            let offset = direction === 'rtl' ? -1 * (selectedTab.offsetParent?.offsetWidth - selectedTab.offsetWidth - selectedTab.offsetLeft) : selectedTab.offsetLeft;
            styleObj.transform = orientation === 'vertical' ? `translateY(${selectedTab.offsetTop}px)` : `translateX(${offset}px)`;
            if (orientation === 'horizontal') styleObj.width = `${selectedTab.offsetWidth}px`;
            else styleObj.height = `${selectedTab.offsetHeight}px`;
            setStyle(styleObj);
        }
    }, [
        direction,
        setStyle,
        selectedTab,
        orientation
    ]);
    (0, _utils1.useLayoutEffect)(()=>{
        onResize();
    }, [
        onResize,
        state?.selectedItem?.key,
        direction,
        orientation,
        density
    ]);
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
        style: {
            ...style
        },
        className: selectedIndicator({
            isDisabled,
            orientation
        })
    });
}
const tabs = function anonymous(props, overrides) {
    let rules = " .";
    let matches = (overrides || '').match(/(?:^|\s)(?:y|z|A|B|_9|_8|h|_5|_4|__A|__c|__d|__a|__b|U|__Q|X|Z|V|W|l|q|r|k|o|p)[^\s]+/g) || [];
    rules += matches.join('');
    let $_8 = false;
    for (let p of matches)if (/^\s*_8/.test(p)) $_8 = true;
    rules += ' _Zd';
    if (!$_8) rules += ' _8-3t1x';
    rules += ' _c-bc1l9oh';
    rules += ' _c-1uotwbwg';
    rules += ' _c-eo0c6sf';
    rules += ' _c-enzzrge';
    rules += ' _c-enzykdd';
    rules += ' _c-enzwzjc';
    rules += ' _c-enzrfpb';
    rules += ' _ca';
    rules += ' _eb';
    if (props.orientation === "horizontal") rules += ' _6b';
    return rules;
};
function Tabs(props, ref) {
    [props, ref] = (0, _useSpectrumContextProps.useSpectrumContextProps)(props, ref, TabsContext);
    let { density = 'regular', isDisabled, disabledKeys, orientation = 'horizontal' } = props;
    let domRef = (0, _utils.useDOMRef)(ref);
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactAriaComponents.Tabs), {
        ...props,
        ref: domRef,
        style: props.UNSAFE_style,
        className: (renderProps)=>(props.UNSAFE_className || '') + tabs({
                ...renderProps
            }, props.styles),
        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactAriaComponents.Provider), {
            values: [
                [
                    TabsContext,
                    {
                        density,
                        isDisabled,
                        disabledKeys,
                        orientation
                    }
                ]
            ],
            children: props.children
        })
    });
}
/**
 * Tabs organize content into multiple sections and allow users to navigate between them. The content under the set of tabs should be related and form a coherent unit.
 */ const _Tabs = /*#__PURE__*/ (0, _react.forwardRef)(Tabs);
try {
    // @ts-ignore
    TabPanel.displayName = "TabPanel";
    // @ts-ignore
    TabPanel.__docgenInfo = {
        "description": "",
        "displayName": "TabPanel",
        "props": {
            "children": {
                "defaultValue": null,
                "description": "The content to display in the tab panels.",
                "name": "children",
                "required": false,
                "type": {
                    "name": "ReactNode"
                }
            },
            "shouldForceMount": {
                "defaultValue": {
                    value: "false"
                },
                "description": "Whether to mount the tab panel in the DOM even when it is not currently selected.\nInactive tab panels are inert and cannot be interacted with. They must be styled appropriately so this is clear to the user visually.",
                "name": "shouldForceMount",
                "required": false,
                "type": {
                    "name": "boolean"
                }
            },
            "styles": {
                "defaultValue": null,
                "description": "Spectrum-defined styles, returned by the `style()` macro.",
                "name": "styles",
                "required": false,
                "type": {
                    "name": "StylesPropWithHeight"
                }
            },
            "UNSAFE_className": {
                "defaultValue": null,
                "description": "Sets the CSS [className](https://developer.mozilla.org/en-US/docs/Web/API/Element/className) for the element. Only use as a **last resort**. Use the `style` macro via the `styles` prop instead.",
                "name": "UNSAFE_className",
                "required": false,
                "type": {
                    "name": "string"
                }
            },
            "UNSAFE_style": {
                "defaultValue": null,
                "description": "Sets inline [style](https://developer.mozilla.org/en-US/docs/Web/API/HTMLElement/style) for the element. Only use as a **last resort**. Use the `style` macro via the `styles` prop instead.",
                "name": "UNSAFE_style",
                "required": false,
                "type": {
                    "name": "CSSProperties"
                }
            }
        }
    };
    // @ts-ignore
    if (typeof STORYBOOK_REACT_CLASSES !== "undefined") // @ts-ignore
    STORYBOOK_REACT_CLASSES["packages/@react-spectrum/s2/src/Tabs.tsx#TabPanel"] = {
        docgenInfo: TabPanel.__docgenInfo,
        name: "TabPanel",
        path: "packages/@react-spectrum/s2/src/Tabs.tsx#TabPanel"
    };
} catch (__react_docgen_typescript_loader_error) {}
try {
    // @ts-ignore
    Tab.displayName = "Tab";
    // @ts-ignore
    Tab.__docgenInfo = {
        "description": "",
        "displayName": "Tab",
        "props": {
            "children": {
                "defaultValue": null,
                "description": "The content to display in the tab.",
                "name": "children",
                "required": false,
                "type": {
                    "name": "ReactNode"
                }
            },
            "download": {
                "defaultValue": null,
                "description": "Causes the browser to download the linked URL. A string may be provided to suggest a file name. See [MDN](https://developer.mozilla.org/en-US/docs/Web/HTML/Element/a#download).",
                "name": "download",
                "required": false,
                "type": {
                    "name": "string | boolean"
                }
            },
            "href": {
                "defaultValue": null,
                "description": "A URL to link to. See [MDN](https://developer.mozilla.org/en-US/docs/Web/HTML/Element/a#href).",
                "name": "href",
                "required": false,
                "type": {
                    "name": "string"
                }
            },
            "hrefLang": {
                "defaultValue": null,
                "description": "Hints at the human language of the linked URL. See[MDN](https://developer.mozilla.org/en-US/docs/Web/HTML/Element/a#hreflang).",
                "name": "hrefLang",
                "required": false,
                "type": {
                    "name": "string"
                }
            },
            "isDisabled": {
                "defaultValue": null,
                "description": "Whether the tab is disabled.",
                "name": "isDisabled",
                "required": false,
                "type": {
                    "name": "boolean"
                }
            },
            "ping": {
                "defaultValue": null,
                "description": "A space-separated list of URLs to ping when the link is followed. See [MDN](https://developer.mozilla.org/en-US/docs/Web/HTML/Element/a#ping).",
                "name": "ping",
                "required": false,
                "type": {
                    "name": "string"
                }
            },
            "referrerPolicy": {
                "defaultValue": null,
                "description": "How much of the referrer to send when following the link. See [MDN](https://developer.mozilla.org/en-US/docs/Web/HTML/Element/a#referrerpolicy).",
                "name": "referrerPolicy",
                "required": false,
                "type": {
                    "name": "enum",
                    "value": [
                        {
                            "value": "\"\""
                        },
                        {
                            "value": "\"no-referrer\""
                        },
                        {
                            "value": "\"no-referrer-when-downgrade\""
                        },
                        {
                            "value": "\"origin\""
                        },
                        {
                            "value": "\"origin-when-cross-origin\""
                        },
                        {
                            "value": "\"same-origin\""
                        },
                        {
                            "value": "\"strict-origin\""
                        },
                        {
                            "value": "\"strict-origin-when-cross-origin\""
                        },
                        {
                            "value": "\"unsafe-url\""
                        }
                    ]
                }
            },
            "rel": {
                "defaultValue": null,
                "description": "The relationship between the linked resource and the current page. See [MDN](https://developer.mozilla.org/en-US/docs/Web/HTML/Attributes/rel).",
                "name": "rel",
                "required": false,
                "type": {
                    "name": "string"
                }
            },
            "routerOptions": {
                "defaultValue": null,
                "description": "Options for the configured client side router.",
                "name": "routerOptions",
                "required": false,
                "type": {
                    "name": "undefined"
                }
            },
            "styles": {
                "defaultValue": null,
                "description": "Spectrum-defined styles, returned by the `style()` macro.",
                "name": "styles",
                "required": false,
                "type": {
                    "name": "StylesProp"
                }
            },
            "target": {
                "defaultValue": null,
                "description": "The target window for the link. See [MDN](https://developer.mozilla.org/en-US/docs/Web/HTML/Element/a#target).",
                "name": "target",
                "required": false,
                "type": {
                    "name": "HTMLAttributeAnchorTarget"
                }
            },
            "UNSAFE_className": {
                "defaultValue": null,
                "description": "Sets the CSS [className](https://developer.mozilla.org/en-US/docs/Web/API/Element/className) for the element. Only use as a **last resort**. Use the `style` macro via the `styles` prop instead.",
                "name": "UNSAFE_className",
                "required": false,
                "type": {
                    "name": "string"
                }
            },
            "UNSAFE_style": {
                "defaultValue": null,
                "description": "Sets inline [style](https://developer.mozilla.org/en-US/docs/Web/API/HTMLElement/style) for the element. Only use as a **last resort**. Use the `style` macro via the `styles` prop instead.",
                "name": "UNSAFE_style",
                "required": false,
                "type": {
                    "name": "CSSProperties"
                }
            }
        }
    };
    // @ts-ignore
    if (typeof STORYBOOK_REACT_CLASSES !== "undefined") // @ts-ignore
    STORYBOOK_REACT_CLASSES["packages/@react-spectrum/s2/src/Tabs.tsx#Tab"] = {
        docgenInfo: Tab.__docgenInfo,
        name: "Tab",
        path: "packages/@react-spectrum/s2/src/Tabs.tsx#Tab"
    };
} catch (__react_docgen_typescript_loader_error) {}
try {
    // @ts-ignore
    TabList.displayName = "TabList";
    // @ts-ignore
    TabList.__docgenInfo = {
        "description": "",
        "displayName": "TabList",
        "props": {
            "children": {
                "defaultValue": null,
                "description": "The content to display in the tablist.",
                "name": "children",
                "required": false,
                "type": {
                    "name": "ReactNode"
                }
            },
            "dependencies": {
                "defaultValue": null,
                "description": "Values that should invalidate the item cache when using dynamic collections.",
                "name": "dependencies",
                "required": false,
                "type": {
                    "name": "any[]"
                }
            },
            "items": {
                "defaultValue": null,
                "description": "Item objects in the collection.",
                "name": "items",
                "required": false,
                "type": {
                    "name": "Iterable<T>"
                }
            },
            "styles": {
                "defaultValue": null,
                "description": "Spectrum-defined styles, returned by the `style()` macro.",
                "name": "styles",
                "required": false,
                "type": {
                    "name": "StylesProp"
                }
            },
            "UNSAFE_className": {
                "defaultValue": null,
                "description": "Sets the CSS [className](https://developer.mozilla.org/en-US/docs/Web/API/Element/className) for the element. Only use as a **last resort**. Use the `style` macro via the `styles` prop instead.",
                "name": "UNSAFE_className",
                "required": false,
                "type": {
                    "name": "string"
                }
            },
            "UNSAFE_style": {
                "defaultValue": null,
                "description": "Sets inline [style](https://developer.mozilla.org/en-US/docs/Web/API/HTMLElement/style) for the element. Only use as a **last resort**. Use the `style` macro via the `styles` prop instead.",
                "name": "UNSAFE_style",
                "required": false,
                "type": {
                    "name": "CSSProperties"
                }
            }
        }
    };
    // @ts-ignore
    if (typeof STORYBOOK_REACT_CLASSES !== "undefined") // @ts-ignore
    STORYBOOK_REACT_CLASSES["packages/@react-spectrum/s2/src/Tabs.tsx#TabList"] = {
        docgenInfo: TabList.__docgenInfo,
        name: "TabList",
        path: "packages/@react-spectrum/s2/src/Tabs.tsx#TabList"
    };
} catch (__react_docgen_typescript_loader_error) {}
try {
    // @ts-ignore
    TabsContext.displayName = "TabsContext";
    // @ts-ignore
    TabsContext.__docgenInfo = {
        "description": "",
        "displayName": "TabsContext",
        "props": {
            "value": {
                "defaultValue": null,
                "description": "",
                "name": "value",
                "required": true,
                "type": {
                    "name": "ContextValue<TabsProps, DOMRefValue<HTMLDivElement>>"
                }
            }
        }
    };
    // @ts-ignore
    if (typeof STORYBOOK_REACT_CLASSES !== "undefined") // @ts-ignore
    STORYBOOK_REACT_CLASSES["packages/@react-spectrum/s2/src/Tabs.tsx#TabsContext"] = {
        docgenInfo: TabsContext.__docgenInfo,
        name: "TabsContext",
        path: "packages/@react-spectrum/s2/src/Tabs.tsx#TabsContext"
    };
} catch (__react_docgen_typescript_loader_error) {}
try {
    // @ts-ignore
    _Tabs.displayName = "_Tabs";
    // @ts-ignore
    _Tabs.__docgenInfo = {
        "description": "Tabs organize content into multiple sections and allow users to navigate between them. The content under the set of tabs should be related and form a coherent unit.",
        "displayName": "_Tabs",
        "props": {
            "children": {
                "defaultValue": null,
                "description": "The content to display in the tabs.",
                "name": "children",
                "required": false,
                "type": {
                    "name": "ReactNode"
                }
            },
            "defaultSelectedKey": {
                "defaultValue": null,
                "description": "The initial selected key in the collection (uncontrolled).",
                "name": "defaultSelectedKey",
                "required": false,
                "type": {
                    "name": "Key"
                }
            },
            "density": {
                "defaultValue": {
                    value: "'regular'"
                },
                "description": "The amount of space between the tabs.",
                "name": "density",
                "required": false,
                "type": {
                    "name": "enum",
                    "value": [
                        {
                            "value": "\"compact\""
                        },
                        {
                            "value": "\"regular\""
                        }
                    ]
                }
            },
            "disabledKeys": {
                "defaultValue": null,
                "description": "The item keys that are disabled. These items cannot be selected, focused, or otherwise interacted with.",
                "name": "disabledKeys",
                "required": false,
                "type": {
                    "name": "Iterable<Key>"
                }
            },
            "isDisabled": {
                "defaultValue": null,
                "description": "Whether the TabList is disabled.\nShows that a selection exists, but is not available in that circumstance.",
                "name": "isDisabled",
                "required": false,
                "type": {
                    "name": "boolean"
                }
            },
            "keyboardActivation": {
                "defaultValue": {
                    value: "'automatic'"
                },
                "description": "Whether tabs are activated automatically on focus or manually.",
                "name": "keyboardActivation",
                "required": false,
                "type": {
                    "name": "enum",
                    "value": [
                        {
                            "value": "\"manual\""
                        },
                        {
                            "value": "\"automatic\""
                        }
                    ]
                }
            },
            "orientation": {
                "defaultValue": {
                    value: "'horizontal'"
                },
                "description": "The orientation of the tabs.",
                "name": "orientation",
                "required": false,
                "type": {
                    "name": "enum",
                    "value": [
                        {
                            "value": "\"vertical\""
                        },
                        {
                            "value": "\"horizontal\""
                        }
                    ]
                }
            },
            "selectedKey": {
                "defaultValue": null,
                "description": "The currently selected key in the collection (controlled).",
                "name": "selectedKey",
                "required": false,
                "type": {
                    "name": "Key | null"
                }
            },
            "styles": {
                "defaultValue": null,
                "description": "Spectrum-defined styles, returned by the `style()` macro.",
                "name": "styles",
                "required": false,
                "type": {
                    "name": "StylesPropWithHeight"
                }
            },
            "UNSAFE_className": {
                "defaultValue": null,
                "description": "Sets the CSS [className](https://developer.mozilla.org/en-US/docs/Web/API/Element/className) for the element. Only use as a **last resort**. Use the `style` macro via the `styles` prop instead.",
                "name": "UNSAFE_className",
                "required": false,
                "type": {
                    "name": "string"
                }
            },
            "UNSAFE_style": {
                "defaultValue": null,
                "description": "Sets inline [style](https://developer.mozilla.org/en-US/docs/Web/API/HTMLElement/style) for the element. Only use as a **last resort**. Use the `style` macro via the `styles` prop instead.",
                "name": "UNSAFE_style",
                "required": false,
                "type": {
                    "name": "CSSProperties"
                }
            },
            "onSelectionChange": {
                "defaultValue": null,
                "description": "Handler that is called when the selection changes.",
                "name": "onSelectionChange",
                "required": false,
                "type": {
                    "name": "((key: Key) => void)"
                }
            },
            "key": {
                "defaultValue": null,
                "description": "",
                "name": "key",
                "required": false,
                "type": {
                    "name": "Key | null"
                }
            },
            "ref": {
                "defaultValue": null,
                "description": "Allows getting a ref to the component instance.\nOnce the component unmounts, React will set `ref.current` to `null`\n(or call the ref with `null` if you passed a callback ref).\n@see {@link https://react.dev/learn/referencing-values-with-refs#refs-and-the-dom React Docs}",
                "name": "ref",
                "required": false,
                "type": {
                    "name": "Ref<DOMRefValue<HTMLDivElement>>"
                }
            }
        }
    };
    // @ts-ignore
    if (typeof STORYBOOK_REACT_CLASSES !== "undefined") // @ts-ignore
    STORYBOOK_REACT_CLASSES["packages/@react-spectrum/s2/src/Tabs.tsx#_Tabs"] = {
        docgenInfo: _Tabs.__docgenInfo,
        name: "_Tabs",
        path: "packages/@react-spectrum/s2/src/Tabs.tsx#_Tabs"
    };
} catch (__react_docgen_typescript_loader_error) {}

},{"0":"fWNj9","1":"6VX3t","2":"dbdLf","3":"eeeiQ","4":"cfbf1","5":"bTYJ0","6":"lt5NV","7":"efqqG","8":"kFnhW","react/jsx-runtime":"2JzhG","react-aria-components":"8nuKL","./CenterBaseline":"hXatv","react":"jEiK2","./Icon":"1OC2a","./Content":"aBWEm","@react-spectrum/utils":"bebxO","@react-aria/utils":"e9Yvo","@react-aria/i18n":"hFrKJ","./useSpectrumContextProps":"ileU6","@parcel/transformer-js/src/esmodule-helpers.js":"diccK"}],"fWNj9":[function() {},{}],"6VX3t":[function() {},{}],"dbdLf":[function() {},{}],"eeeiQ":[function() {},{}],"cfbf1":[function() {},{}],"bTYJ0":[function() {},{}],"lt5NV":[function() {},{}],"efqqG":[function() {},{}],"kFnhW":[function() {},{}]},[], null, "parcelRequire94c2")

//# sourceMappingURL=Illustrations.cde016c3.js.map
